var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"target":"_blank","href":_vm.url,"title":("Twitter status ID " + _vm.id)}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }